import { QRCodeSVG } from "qrcode.react";

// Structural, not the full GatePassTemplate type -- this component only
// ever reads these three fields, so any source (the admin panel's full
// GatePassTemplate, or the public badge page's trimmed PublicBadgeTemplate)
// can be passed without a type mismatch.
type QrBadgeTemplate = {
  variant: string;
  accent_color: string;
  footer_text?: string | null;
};

export function QrBadge({
  badgeCode,
  template,
}: {
  badgeCode: string;
  template?: QrBadgeTemplate | null;
}) {
  if (!template) {
    return (
      <div className="qr-panel">
        <QRCodeSVG value={badgeCode} size={160} />
        <code>{badgeCode}</code>
      </div>
    );
  }

  return (
    <div
      className={`qr-panel gate-pass-preview gate-pass-preview--${template.variant}`}
      style={{ borderColor: template.accent_color }}
    >
      <p className="gate-pass-preview-brand" style={{ color: template.accent_color }}>
        0todeploy VMS
      </p>
      <QRCodeSVG value={badgeCode} size={160} />
      <code>{badgeCode}</code>
      {template.footer_text ? <p className="gate-pass-preview-footer">{template.footer_text}</p> : null}
    </div>
  );
}
